import { NgxLoggerLevel } from 'ngx-logger';
declare global {
    interface Window {
        candConfig: any;
        tC: any;
        /* eslint-disable-next-line @typescript-eslint/naming-convention */
        tc_vars: any;
        /* eslint-disable-next-line @typescript-eslint/naming-convention */
        tc_events_global: any;
        /* eslint-disable-next-line @typescript-eslint/naming-convention */
        EA_collector: any;
    }
}

const getHippoConfig = (key) =>
    window.candConfig && window.candConfig[key] ? window.candConfig[key] : null;

let levelLoggerConfig = NgxLoggerLevel.INFO;
const diagnosticLoggingLevel: string = getHippoConfig('diagnosticLoggingLevel');
if (diagnosticLoggingLevel && diagnosticLoggingLevel.length >= 3) {
    levelLoggerConfig = NgxLoggerLevel[diagnosticLoggingLevel];
}
export const environment = {
    production: true,
    websiteName: 'eade',
    apiUrl: window.candConfig.url.api,
    //example launch param
    ihmLaunchParams: window.candConfig.ihmLaunchParams,
    bundleHostUrl: `${window.location.protocol}//${window.location.host}`,
    tagCommanderUrl: window.candConfig.tagCommanderUrl,
    tagCommanderVarUrl: window.candConfig.tagCommanderVarUrl,
    assetsFolder: window.candConfig.url.mocks,
    refreshToken: window.candConfig.refresh,
    contractualDocument: window.candConfig.contractualDocument,
    infoDocument: window.candConfig.infoDocument,
    //todo could be set by hippo at runtime with window.candConfig
    loggerConfig: {
        level: levelLoggerConfig,
        disableConsoleLogging: getHippoConfig('diagnosticLoggingDisableConsole')
            ? true
            : false,
        diagnosticLoggingServerLevel:
            getHippoConfig('diagnosticLoggingServerLevel') || 'OFF',
        diagnosticLoggingMissingKeyI18n: getHippoConfig(
            'diagnosticLoggingMissingKeyI18n'
        ),
        diagnosticLoggingErrorCallWebserviceI18n: getHippoConfig(
            'diagnosticLoggingErrorCallWebserviceI18n'
        ),
        diagnosticLoggingException: getHippoConfig(
            'diagnosticLoggingException'
        ),
        enableSourceMaps: true,
    },
    geolocApiKey: window.candConfig.geolocApiKey,
    filteredCodeAIADocuments: window.candConfig.filteredCodeAIADocuments,
};
